export interface ProductsForCreatePurchaseOrder {
  id: string;
  productKey: string;
  productDescription: string;
  owner: string;
  productTypeId: string;
  productTypeDescription: string;
  unitOfMeasureDescription: string;
  clearanceProduct: string;
  obsoleteSupplier: string;
  requirements: number;
  reservedQuantity: number;
  stockQuantity: number;
  callOffStock: number;
  allocatedQuantity: number;
  availableStock: number;
  secondStock: number;
  purchaseOrderQuantity: number;
  balance: number;
  minimumOrderQuantity: number;
  minimumStockQuantity: number;
  supplierKey: string;
  supplierName: string;
  price: number;
  currencyCode: string;
  minimumStockLevel: number;
  quantityToOrder: number;
  quantityToReturn: number;
}
